import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { breadcrumb } from '../../../helpers/page-front';

const Breadcrumb = props => {

    const page = breadcrumb(props);
    if (!page.title) return null;

    return (
        <div className="container g-pt-140 g-pb-20">
            <div className="u-heading-v3-1 g-brd-bottom g-brd-gray-light-v3 g-pt-20">
                <h2 className="h3 u-heading-v3__title g-brd-primary g-brd-bottom-2--md g-font-size-22 g-font-weight-600 g-line-height-0_9">{page.title}</h2>
                <ul className="g-hidden-xs-down u-list-inline pull-right g-pt-2 g-font-size-13">
                    <li className="list-inline-item g-mr-5 g-hidden-xs-down">
                        <Link to="/" className="u-link-v5 g-color-main">Home</Link>
                    </li>
                    <li className="list-inline-item g-mr-5">
                        <i className="g-color-gray-light-v2 g-mr-5">/</i>
                        <Link to={page.path} className="u-link-v5 g-color-main">{page.category}</Link>
                    </li>
                    {page.subCategory &&
                        <li className="list-inline-item g-color-primary"><i className="g-color-gray-light-v2 g-mr-5">/</i>{page.subCategory}</li>
                    }
                </ul>
            </div>
        </div>
    )
}

export default withRouter(Breadcrumb);


// WEBPACK FOOTER //
// ./src/components/front/content/breadcrumb.js